module.exports = __webpack_public_path__ + "img/bg_messagechat.a157f4fd.png";